export default defineNuxtPlugin(async () => {
  const settingsStore = useSettingsStore();
  const tokenStore = useTokenStore();
  const roleManagerStore = useRoleManagerStore();

  // Using vue-router to get the current path sometimes returns an empty string,
  // so we are just getting the path directly from the window object instead.
  // Strip scheme + host to get the path, works for any URL scheme
  // (http://, https://, capacitor://, ionic://, etc.)
  const path = window.location.href.replace(/^[^:]+:\/\/[^/]+/, '');

  const promises = [
    settingsStore.loadDeviceSettings()
  ];

  if (path === '/') {
    await Promise.all(promises);

    return;
  }

  if (await tokenStore.hasValidRefreshToken() === false) {
    await Promise.all(promises);
    window.location.href = '/';

    return;
  }
  
  if (await tokenStore.hasValidAccessToken() === false) {
    await tokenStore.refreshAccessToken();
  }

  promises.push(loginHelpers.fetchConfigurationData());

  await Promise.all(promises);

  if (roleManagerStore.isRoutePermitted(path) === false) {
    window.location.href = roleManagerStore.loginDestination;
  }
  
});
